import m from './module';

class RecapConfigService {

  constructor() {
    this.config = {};
  }
  getConfig() {
    return this.config;
  }

  setConfig(config) {
    this.config = config;
  }
}

export default RecapConfigService;

m.service('RecapConfigService', RecapConfigService);
